import { useState, useContext } from "react";
import apiClient from "../api/apiClient";
import "../css/SetNewPin.css";
import "../css/mainhome.css";
import { AppContext } from "../context/AppContext";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import kkko from "../assets/icons/logo.png";

export default function SetNewPinScreen() {
  const { mobileNo, setUser } = useContext(AppContext);
  const [enteredPassword, setEnteredPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    const loginMobileNo =
      mobileNo ||
      localStorage.getItem("mobileNo") ||
      localStorage.getItem("lastLoginMobileNo") ||
      "";

    if (loginMobileNo.length !== 10) {
      toast.warn("Please enter your mobile number first.");
      navigate("/enter-mobile", { replace: true });
      return;
    }

    if (!enteredPassword) {
      toast.warn("Please enter your password.");
      return;
    }

    setIsLoading(true);

    try {
      const res = await apiClient.post("/user-login", {
        mobileNo: loginMobileNo,
        password: enteredPassword,
        fcmToken: "",
      });

      if (res.data.status === true) {
        const { registerId, accessToken } = res.data.info;

        localStorage.removeItem("accessToken");
        localStorage.removeItem("registerId");

        localStorage.setItem("registerId", registerId);
        localStorage.setItem("accessToken", accessToken);

        localStorage.setItem("mobileNo", loginMobileNo);
        localStorage.setItem("lastLoginMobileNo", loginMobileNo);

        const profileRes = await apiClient.post(
          "/user-details-by-register-id",
          { registerId }
        );

        if (profileRes.data.status && profileRes.data.info) {
          const userInfo = profileRes.data.info;

          localStorage.setItem(
            "userProfile",
            JSON.stringify(userInfo)
          );
          localStorage.setItem(
            "walletBalance",
            userInfo.walletBalance
          );

          if (setUser) setUser(userInfo);

          toast.success("Login successful!");
          navigate("/home", { replace: true });
        } else {
          toast.warn(
            "Login successful, but failed to load profile."
          );
          navigate("/home", { replace: true });
        }
      } else {
        toast.error(
          res.data.msg || "Login failed. Please try again."
        );
      }
    } catch (err) {
      console.error("Login error:", err?.response || err);
      toast.error("Something went wrong. Try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="mainhome-screen-wrapper">
      <div className="top-header">Login</div>

      <div className="setpin-content-wrapper">
        <div className="logo-image-wrapper">
          <img src={kkko} alt="Logo" className="sararr" />
        </div>

        <div className="password-group">
          <input
            type="password"
            className="text-input"
            value={enteredPassword}
            placeholder="Enter Password"
            onChange={(e) =>
              setEnteredPassword(e.target.value)
            }
          />
        </div>

        <button
          className="setpin-btn"
          onClick={handleLogin}
          disabled={isLoading}
        >
          {isLoading ? "LOGGING IN..." : "LOGIN"}
        </button>
      </div>
    </div>
  );
}
